import { Link } from "react-router-dom";

export default function SolarHighlight() {
  return (
    <section className="py-16 px-6 max-w-6xl mx-auto" data-testid="solar-highlight">
      <div className="rounded-2xl overflow-hidden gold-border relative">
        <img
          src="https://images.unsplash.com/photo-1613665813446-82a78c468a1d?q=85&w=1600&auto=format&fit=crop"
          alt="Modern solar-powered home with rooftop solar panels"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0c]/95 via-[#0a0a0c]/80 to-[#0a0a0c]/40"></div>
        <div className="relative p-8 sm:p-12 max-w-xl">
          <span className="text-[10px] font-mono uppercase tracking-widest text-[#d4af37]">Now Installing · DFW Metroplex</span>
          <h2 className="font-display text-3xl sm:text-4xl uppercase tracking-tight text-white mt-2">Solar Panel Installation</h2>
          <p className="text-sm text-zinc-300 leading-relaxed mt-4">
            Professional residential and commercial solar panel installation, supported by licensed
            electrical partners.
          </p>
          <Link to="/solar-installation" data-testid="solar-highlight-btn"
            className="inline-block mt-6 px-6 py-3 rounded bg-gradient-to-r from-[#d4af37] to-[#e6ca65] text-black font-bold uppercase tracking-wider text-xs hover:opacity-95 transition-opacity">
            Explore Solar Services →
          </Link>
        </div>
      </div>
    </section>
  );
}
